module.exports = __webpack_public_path__ + "static/media/galerija_2021 (17)-min.eeb27c26.jpg";